import {
    Badge,
    Box,
    Button,
    Group,
    Modal,
    NumberInput,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { genericValidator } from '../../../utils/validation';
import { hasRole } from '../../../utils/roles';
import useAddUserBalance from '../../../http/mutations/users/useAddUserBalance';
import { useEffect } from 'react';
import { useForm } from '@mantine/form';

const AddBalanceModal = ({ user, opened, close }) => {
    const form = useForm({
        initialValues: {
            userId: user?.id,
            type: 'TopUp',
            amount: 0,
        },

        validate: {
            userId: (value) => {
                const { message } = genericValidator('User ID', value, {
                    required: true,
                });
                return message;
            },
            amount: (value) => {
                if (!value) {
                    return 'Top-up must be greater than 0';
                }
            },
        },
    });

    useEffect(() => {
        if (opened) {
            form.setInitialValues({
                userId: user?.id,
                type: 'TopUp',
                amount: 0,
            });
            form.reset();
        }
    }, [opened]);

    const { isPending, mutate: addOrUpdate } = useAddUserBalance();

    const onSubmit = (model) => {
        addOrUpdate(model, {
            onSuccess(data, variables, context) {
                close();
            },
            onError(error, variables, context) {
                // setError(error);
            },
        });
    };

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size={'md'}>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>Add Balance - {user?.username}</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack gap={'xs'}>
                            <Select
                                label='Type'
                                placeholder={'Select type'}
                                size={'xs'}
                                data={['TopUp', 'Credit']}
                                key={form.key('type')}
                                {...form.getInputProps('type')}
                            />

                            <NumberInput
                                label='Top-up Amount'
                                placeholder={'Enter top-up'}
                                leftSection={'$'}
                                size={'xs'}
                                decimalScale={2}
                                key={form.key('amount')}
                                {...form.getInputProps('amount')}
                            />

                            <Group justify='flex-end'>
                                <Button
                                    type={'submit'}
                                    disabled={isPending || !form.isValid()}
                                    rightSection={
                                        isPending ? (
                                            <FontAwesomeIcon
                                                icon={faSpinnerThird}
                                                spin
                                            />
                                        ) : null
                                    }>
                                    Add {form.values.type}
                                </Button>
                            </Group>
                        </Stack>
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default AddBalanceModal;
